export default __webpack_public_path__ + "static/media/vr_light.72111831.png";